import React, { useEffect, useState } from "react";
import MarkdownPreview from "@uiw/react-markdown-preview";

const MessageAIComponent = ({ message, messageId, onFeedback, showFeedback = true, is_good_answered }) => {
  const [dots, setDots] = useState("");
  useEffect(() => {
    let interval;
    if (!message) {
      interval = setInterval(() => {
        setDots((prevDots) => (prevDots.length < 3 ? prevDots + "." : ""));
      }, 500);
    }
    return () => clearInterval(interval);
  }, [message]);

  const dotStyle = {
    fontSize: "24px",
    color: "black",
    fontFamily: "Arial, sans-serif",
    fontWeight: "bold",
  };

  const communStyle = {
    backgroundColor: "transparent",
    color: "#000000",
  };

  const style = message.error ? { color: "red" } : {};

  const processedMessage = message
    ? message.text.replace(/\[SPACE\]/g, " ").replace(/\[RETURN\]/g, "\n")
    : message;

  return (
    <div>
      {!message ? (
        <span style={dotStyle}>{dots}</span>
      ) : (
        <>
          <MarkdownPreview
            source={processedMessage}
            style={{ ...communStyle, ...style }}
            components={{ a: ({ node, ...props }) => renderLink(props) }}
          />
        </>
      )}
    </div>
  );
};

const renderLink = (props) => {
  return (
    <a
      {...props}
      style={{ color: "blue", textDecoration: "underline" }}
      target="_blank"
      rel="noopener noreferrer"
    >
      {props.children}
    </a>
  );
};

export default MessageAIComponent;
